// Registry for the three static legal documents (mentions légales, politique de
// confidentialité, CGU). Same "static markdown, bundled via Vite `?raw`" mechanism
// as content/aide — see that folder's index.ts for the rationale.

import mentionsLegalesContent from "./mentions-legales.md?raw";
import politiqueConfidentialiteContent from "./politique-confidentialite.md?raw";
import cguContent from "./cgu.md?raw";

export interface LegalDocument {
  slug: string;
  title: string;
  /** Short reference shown on the letterhead corner stamp — a filing number, not a description. */
  reference: string;
  lastUpdated: string | null;
  content: string;
}

export const LEGAL_DOCUMENTS: Record<"mentions-legales" | "politique-confidentialite" | "cgu", LegalDocument> = {
  "mentions-legales": {
    slug: "mentions-legales",
    title: "Mentions légales",
    reference: "RCCM GA-LBV-01-2021-A10-00554",
    lastUpdated: null,
    content: mentionsLegalesContent,
  },
  "politique-confidentialite": {
    slug: "politique-confidentialite",
    title: "Politique de confidentialité",
    reference: "Loi n°001/2011 mod. loi n°025/2023",
    lastUpdated: "6 août 2026",
    content: politiqueConfidentialiteContent,
  },
  cgu: {
    slug: "cgu",
    title: "Conditions générales d'utilisation",
    reference: "Usage interne — Le Prestigieux",
    lastUpdated: "6 août 2026",
    content: cguContent,
  },
};
